export const getFileDetails = file => {
  const { name, type, size, lastModified } = file
  return {
    name,
    type,
    size: size > 1000000 ? `${size / 1000000}Mb` : `${size / 1000}Kb`,
    'Last Modified': new Date(lastModified).toLocaleString('en-GB', {
      timeZone: 'Asia/Kolkata'
    })
  }
}

export const debounce = (func, wait, immediate) => {
  let timeout
  return function () {
    const context = this,
      args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}



/** WEBPACK FOOTER **
 ** ./src/lib/helper.js
 **/